export default __webpack_public_path__ + "c663e8a881b76bbf3db81f90a3d6a401.svg";